import { VendorBuyingAgreementBuyOpportunityDocuments } from '../../../components/Vendor';

export function BuyingAgreementBuyOpportunityDocuments() {
  return <VendorBuyingAgreementBuyOpportunityDocuments />;
}
